<script>
export default {};
</script>

<template>
  <div class="row">
    <div class="col-md-6 col-12">
      <slot name="left-6"></slot>
    </div>

    <div class="col-md-6 col-12">
      <slot name="right-6"></slot>
    </div>

    <div class="col-md-8 col-12">
      <slot name="left-8"></slot>
    </div>

    <div class="col-md-4 col-12">
      <slot name="right-4"></slot>
    </div>

    <div class="col-md-4 col-12">
      <slot name="left-4"></slot>
    </div>

    <div class="col-md-8 col-12">
      <slot name="right-8"></slot>
    </div>

    <div class="col-12">
      <slot name="center"></slot>
    </div>
  </div>
</template>

<style></style>
